__turbopack_context__.v({
  "close": "close-button-module-scss-module__DTrAia__close",
});
